import { journeysApiRoutes as routes } from './routes';
import { getJourneyPollingPredicate } from './utils/journey-polling-predicate';
export function getJourneysApiV1(httpClient) {
    return {
        getById: (journeyId)=>httpClient.get(routes.getById(journeyId))
        ,
        getByReference: (journeyReference)=>httpClient.get(routes.getByReference(journeyReference), {
                pollingConfiguration: {
                    predicate: getJourneyPollingPredicate([
                        404
                    ]),
                    exponentialWaitTime: true
                }
            })
        ,
        getForCompletedOrder: (orderId)=>httpClient.get(routes.getForCompletedOrder(orderId), {
                pollingConfiguration: {
                    predicate: getJourneyPollingPredicate([]),
                    exponentialWaitTime: true
                }
            })
        ,
        thirdPartyPasses: {
            getAppleWalletPass: (journeyId)=>httpClient.get(routes.thirdPartyPasses.getAppleWalletPass(journeyId))
            ,
            getGooglePayPass: (journeyId)=>httpClient.get(routes.thirdPartyPasses.getGooglePayPass(journeyId))
        }
    };
}

//# sourceMappingURL=get-journeys-api.js.map